<template>
  <div >
    
    <!-- Basic System Info -->
    <div class="system-section">
      <div class="info-grid">
        <div class="info-item">
          <span class="label">Device Model:</span>
          <span class="value">{{ systemInfo?.model || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="label">System Name:</span>
          <span class="value">{{ systemInfo?.sys_name || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="label">Vendor:</span>
          <span class="value">{{ systemInfo?.vendor || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="label">Serial Number:</span>
          <span class="value">{{ systemInfo?.serial || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="label">Hardware Version:</span>
          <span class="value">{{ systemInfo?.hardware || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="label">Firmware Version:</span>
          <span class="value">{{ systemInfo?.firmware || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="label">Web Version:</span>
          <span class="value">{{ systemInfo?.web_version || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="label">Device MAC:</span>
          <span class="value">{{ systemInfo?.device_mac || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="label">Management MAC:</span>
          <span class="value">{{ systemInfo?.mgmt_mac || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="label">Uptime:</span>
          <span class="value">{{ formatUptime(systemInfo?.uptime_seconds) }}</span>
        </div>
        <div class="info-item">
          <span class="label">CSM:</span>
          <span class="value">{{ systemInfo?.csm || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="label">Device Type:</span>
          <span class="value">{{ systemInfo?.device_type || 'N/A' }}</span>
        </div>
      </div>
    </div>

    <!-- Reboot History -->
    <div v-if="systemInfo?.raw?.DeviceRebootReasonList?.length" class="system-section mt-3">
      <h6 class="text-info mb-2">Reboot History</h6>
      <div class="reboot-list">
        <div v-for="(reboot, index) in systemInfo.raw.DeviceRebootReasonList.slice(0, 3)" 
             :key="index" class="reboot-item">
          <span class="reboot-reason">{{ reboot.RebootReasonNote }}</span>
          <span class="reboot-time">{{ formatTimestamp(reboot.RebootReasonTIme) }}</span>
        </div>
      </div>
    </div>

    <!-- No Data Message -->
    <div v-if="!systemInfo" class="text-center text-muted p-3">
      No system information available
    </div>
  </div>
</template>

<script>
export default {
  name: 'EponClodeSystemInfo',
  props: {
    systemInfo: {
      type: Object,
      default: null
    }
  },
  methods: {
    formatUptime(seconds) {
      if (!seconds) return 'N/A';
      
      const days = Math.floor(seconds / (24 * 60 * 60));
      const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((seconds % (60 * 60)) / 60);
      
      if (days > 0) {
        return `${days}d ${hours}h ${minutes}m`;
      } else if (hours > 0) {
        return `${hours}h ${minutes}m`;
      } else {
        return `${minutes}m`;
      }
    },
    
    formatTimestamp(timestamp) {
      if (!timestamp) return 'N/A';
      return new Date(timestamp * 1000).toLocaleString();
    }
  }
}
</script>

<style scoped>

.system-section {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 12px;
}

.system-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 8px 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.label {
  font-weight: 600;
  color: #ccc;
  font-size: 0.875rem;
}

.value {
  font-weight: 500;
  color: #fff;
  font-size: 0.875rem;
  text-align: right;
}

.reboot-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.reboot-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 4px;
  font-size: 0.8rem;
}

.reboot-reason {
  color: #ff6b6b;
  font-weight: 500;
}

.reboot-time {
  color: #ccc;
  font-size: 0.75rem;
}

/* Dark mode support */
.dark-mode .system-info-card {
  background: rgba(255, 255, 255, 0.02);
}

.dark-mode .label {
  color: #aaa;
}

.dark-mode .value {
  color: #e0e0e0;
}
</style>